<template>
    <div  class="labelPopulation mb-30">
        <template v-if="type==3">
            <div class="lab1">
                <p>
                    <img src="../../../assets/images/newIcon/vip_viplabel_icon.png" alt="">
                    筛选标签组成人群
                </p> 
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="全部" name="1"></el-tab-pane>
                    <el-tab-pane label="运营标签" name="2"></el-tab-pane>
                    <el-tab-pane label="规则标签" name="3"></el-tab-pane>
                </el-tabs>
                <el-input v-model="query.keyword_search" placeholder="请输入关键词搜索标签" suffix-icon="el-icon-search"></el-input>
                <p class="ti"> 标签分组<span>（运营标签）</span></p>
                <p class="list">
                    <span>标签sadfasdfasdfdas1</span>
                    <span>标签1</span>
                    <span>标签1</span>
                    <span>标签1</span>
                    <span>标签1</span>
                    <span>标签1</span>
                    <span>标签1</span>
                    <span>标签1</span>
                </p>
                <el-pagination
                    small
                    layout="prev, pager, next"
                    :total="50">
                </el-pagination>
            </div>
            <div class="lab2">
                <p class="mb-30 tit">
                    标签
                </p>
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="标签规则:">
                        <el-radio-group v-model="form.type">
                            <el-radio label="1">满足任意一个标签</el-radio>
                            <el-radio label="2">同时满足所有标签</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="已选标签:">
                        <div>
                            <p class="t">标签分组 <span>（运营标签）</span></p>
                            <p>
                                <el-tag size="medium" closable>小程序模版消息</el-tag>
                                <el-tag size="medium" closable>公众号模版消息</el-tag>
                                <el-tag size="medium" closable>搜索打开</el-tag>
                                <el-tag size="medium" closable>扫描小程序码</el-tag>
                                <el-tag size="medium" closable>扫描小程序码</el-tag>
                                <el-tag size="medium" closable>公众号菜单</el-tag>
                                <el-tag size="medium" closable>公众号文章</el-tag>
                                <el-tag size="medium" closable>长按识别</el-tag>
                                <el-tag size="medium" closable>聊天卡片</el-tag>
                            </p>
                        </div>
                        <div>
                            <p class="t t2">标签分组 <span>（规则标签）</span></p>
                           <p>
                                <el-tag size="medium" closable>小程序模版消息</el-tag>
                                <el-tag size="medium" closable>公众号模版消息</el-tag>
                                <el-tag size="medium" closable>搜索打开</el-tag>
                                <el-tag size="medium" closable>扫描小程序码</el-tag>
                                <el-tag size="medium" closable>扫描小程序码</el-tag>
                                <el-tag size="medium" closable>公众号菜单</el-tag>
                                <el-tag size="medium" closable>公众号文章</el-tag>
                                <el-tag size="medium" closable>长按识别</el-tag>
                                <el-tag size="medium" closable>聊天卡片</el-tag>
                            </p>
                        </div>
                    </el-form-item>
                    
                </el-form>
            </div>
        </template>
        <template v-if="type==1">
            <div class="lab3">
                <el-form ref="form" :model="form" label-width="100px">
                    <el-form-item label="选择标签：">
                        <div class="labelCk">
                            
                            <el-tabs class="mb-15" v-model="activeName" @tab-click="handleClick">
                                <el-tab-pane label="全部" name="1"></el-tab-pane>
                                <el-tab-pane label="运营标签" name="2"></el-tab-pane>
                                <el-tab-pane label="规则标签" name="3"></el-tab-pane>
                            </el-tabs>
                            <el-input class="mb-15" v-model="query.keyword_search" placeholder="请输入关键词搜索标签" suffix-icon="el-icon-search"></el-input>
                            <div class="mb-15" v-for="(item,index) in listLabel" :key='index'>
                                <p class="t">来源标签</p>
                                <p :style="{ 'max-height': item.status ? textHeight : '' }" :class="{ statusText: item.status }" ref="desc">
                                    <el-tag size="medium" v-for="(t,i) in item.tag"  :class="i==0 ? 'active' : ''" :key="i">{{t.name}}</el-tag>
                                </p>
                                <p class="zs" @click="item.status = !item.status" v-if="item.idShowText">
                                <span v-if="item.status">展开 <i class="el-icon-arrow-down"></i></span>
                                <span v-else>收回<i class="el-icon-arrow-up"></i></span>
                                </p>
                            </div>
                            <div>
                                <p class="t t2">分组名称</p>
                                <p>
                                <el-tag size="medium" >小程序模版消息</el-tag>
                                <el-tag size="medium" >公众号模版消息</el-tag>
                                <el-tag size="medium" >搜索打开</el-tag>
                                <el-tag size="medium" >扫描小程序码</el-tag>
                                <el-tag size="medium" >扫描小程序码</el-tag>
                                <el-tag size="medium" >公众号菜单</el-tag>
                                <el-tag size="medium" >公众号文章</el-tag>
                                <el-tag size="medium" >长按识别</el-tag>
                                <el-tag size="medium" >聊天卡片</el-tag>
                            </p>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="标签规则：">
                        <el-radio-group v-model="form.type">
                            <el-radio label="1">满足任意一个标签</el-radio>
                            <el-radio label="2">同时满足所有标签</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="人数预览：">
                         <p class="nums"><el-input v-model="input"></el-input> 人
                            <el-button type="text">计算人群</el-button>
                        </p>
                    </el-form-item>
                </el-form>
                <span class="footer">
                    <el-button class="quxiao" @click="goType(1)">上一步</el-button>
                    <el-button type="primary"  @click="goType(2)">创 建</el-button>
                </span>
            </div>
            
        </template>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
     props:{
        type:{
            type:String,
            default:0
        }
    },
    data() {
        return {
            textHeight:null,
            query:JSON.parse(JSON.stringify(QUERY)),
            activeName: '1' ,
            form:{
                type:"1"
            },
            input:"",
            listLabel:[
                {
                    group_name:"来源标签",
                    status:true,
                    idShowText:true,
                    tag:[{name:"小程序模版消息",tag_id:1},{name:"公众号模版消息",tag_id:2},{name:"搜索打开",tag_id:3},{name:"扫描小程序码",tag_id:4},{name:"扫描小程序码",tag_id:4},{name:"公众号菜单",tag_id:4},{name:"公众号文章",tag_id:4},{name:"长按识别",tag_id:4},{name:"聊天卡片",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},]
                }
            ],
        }
    },
    mounted() {
       this.calculateText(); 
    },
    methods: {
        goType(type){
            this.$emit("dostep",{type,list:this.list});
        },
        handleClick(){

        },
        calculateText() {
            // 这是默认两行数据的高度，一行的高度可以自定义 可以*3 *4达到三行或者四行显示展示和收起的效果
            let twoHeight = 25 * 3;
            this.textHeight = `${twoHeight}px`;
            let l=this.$refs.desc;
            for(let i=0;i<l.length;i++){
                let index=l[i].dataset.index;
                let idx=l[i].dataset.i;
                let curHeight = l[i].offsetHeight;
                let d=this.listLabel[i];
                if (curHeight > twoHeight) {
                d.status = true;
                d.idShowText = true;
                } else {
                d.status = false;
                d.idShowText = false;
                }
            }
        },
    },
}
</script>
<style lang="less" scoped>
.openSpan {
    position: absolute;
    right: 0;
    bottom: -4px;
  }

.zs{
    margin-top:15px;
    text-align: center;
    color:#1890FF;
}
   .titleText {
    // font-weight: bold;
    font-size: 14px;
    line-height: 28px;
  }
  .openClose {
    font-size: 14px;
    color: #258EF7;
  }
  .openSpan {
    position: absolute;
    right: 0;
    bottom: -4px;
  }
  .statusText {
    overflow: hidden;
    display: block;
  }
  .statusText:after {
    // content: "...";
    // position: absolute;
    // bottom: 0;
    // right: 2px;
    // width: 48px;
    // padding-left: 30px;
    // background: linear-gradient(to right, rgba(255,255,255,0.2), #fff 45%);
  }

    .labelPopulation{
        display: flex;
        justify-content: space-between;
        .lab1{
            box-sizing: border-box;
            padding:15px;
            padding-top:30px;
            width:262px;
            border-radius: 8px;
            background: #fff;
            /deep/ .el-tabs__nav-wrap::after{
                display: none;
            }
            /deep/ .el-tabs__nav-scroll{
                display: flex;
                justify-content: center;
            }
            /deep/ .el-input .el-input__inner{
                background: #F1F1F1;
                border-radius: 15px;
                border:0px;
            }
            .ti{
                padding:15px 0;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                span{
                    color:#1E9DFF;
                }
            }
            p{
                img{
                    width:16px;
                    height:16px;
                    vertical-align: middle;
                }
                margin-bottom:15px;
                font-size: 16px;
                font-weight: 500;
                color: #333940;
            }
            .list{
                span{
                    box-sizing: border-box;
                    padding:0 10px;
                    margin-right:10px;
                    margin-bottom:10px;
                    width: 110px;
                    height: 36px;
                    text-align: center;
                    line-height: 36px;
                    display: inline-block;
                    // padding:6px 15px;
                    background: #F2F2F2;
                    border-radius: 18px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #B9B9B9;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    &:nth-child(2n){
                        margin-right:0;
                    }
                }
            }
            .el-pagination{
                text-align: center;
            }
        }
        .lab2{
            padding:30px;
            border-radius: 8px;
            box-sizing: border-box;
            width:-webkit-calc(100% - 300px); 
            width:-moz-calc(100% - 300px); 
            width:calc(100% - 300px); 
            background: #fff;
            .tit{
                font-size: 16px;
                font-weight: 500;
                color: #333940;
                margin-left:15px;
                
            }
            .t{
                margin-bottom:15px;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                span{
                    color:#1E9DFF;
                }
                
            }
            .t2{
                span{
                    color:#FA6400 !important;
                }
            }
            /deep/ .el-tag{
                border-radius: 30px;
                margin-right:10px;
                margin-bottom:10px;
            }
            /deep/ .el-form{
                width:70%;
            }
        }
        .lab3{
            /deep/ .el-form{
                padding:30px;
            }
            // padding:30px;
            border-radius: 8px;
            box-sizing: border-box;
            width:100%; 
            background: #fff;
            .labelCk{
                padding:30px;
                background: #F7F7F7;
                border-radius: 6px;
                /deep/ .el-tabs__nav-wrap::after{
                    display: none;
                }
                /deep/ .el-input .el-input__inner{
                    border-radius: 15px;
                    border:0px;
                }
            }
            .active.el-tag{
                border-radius: 30px;
                margin-right:10px;
                margin-bottom:10px;
                background: rgba(211, 236, 255, 0.39);
                color:#0091FF;
            }
            .tit{
                font-size: 16px;
                font-weight: 500;
                color: #333940;
                margin-left:15px;
                
            }
            .t{
                margin-bottom:15px;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                span{
                    color:#1E9DFF;
                }
                
            }
            .t2{
                span{
                    color:#FA6400 !important;
                }
            }
             /deep/ .el-tag{
                border-radius: 30px;
                margin-right:10px;
                margin-bottom:10px;
                background: #fff;
                color:#777777;
            }
            .nums{
                // padding:0 30px;
                padding-bottom:30px;
                font-size:14px;
                /deep/ .el-input{
                    width:100px;
                     margin:0 10px;
                }
                /deep/ .el-input__inner{
                   
                    background:#F6F6F6;
                    border-radius: 30px;
                }
                /deep/ .el-button{
                    margin-left:15px;
                }
            }
            
            /deep/ .el-form{
                width:70%;
            }
        }
        .quxiao.el-button{
            color:#999;
            background: #fff;
        }
        .footer{
            display: block;
            background: #fff;
            padding:15px 30px;
            border-top:1px solid #ededed;
            .el-button{
                border-radius: 30px;
            }
        }
    }   
    
</style>